import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  // Obtener la ruta solicitada
  const currentPath = window.location.pathname;

  return (
    <div style={styles.body}>
      <div style={styles.card}>
        <div style={styles.appIcon}>
          {/* Asegúrate de tener el logo en la ruta correcta */}
          <img src="/img/logo.webp" alt="Logo de la aplicación" style={styles.iconImage} />
        </div>
        <h1 style={styles.heading}>Error 404</h1>
        <p style={styles.paragraph}>
          La página que buscas no existe. <br />
          La ruta solicitada fue: <strong>{currentPath}</strong>
        </p>
        <Link to="/" style={styles.button}>
          Volver al Inicio
        </Link>
      </div>
    </div>
  );
};

const styles = {
  body: {
    fontFamily: "'Roboto', 'Segoe UI', sans-serif",
    backgroundColor: '#fef7ff',
    color: '#1c1b1f',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    padding: '24px',
  },
  card: {
    backgroundColor: '#ffffff',
    borderRadius: '28px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
    padding: '32px 24px',
    maxWidth: '420px',
    width: '100%',
    textAlign: 'center',
  },
  appIcon: {
    width: '72px',
    height: '72px',
    margin: '0 auto 20px',
    borderRadius: '16px',
    overflow: 'hidden',
  },
  iconImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
  },
  heading: {
    fontSize: '3rem',
    fontWeight: '500',
    marginBottom: '16px',
  },
  paragraph: {
    fontSize: '1.1rem',
    lineHeight: '1.5',
    marginBottom: '32px',
    color: '#49454f',
  },
  button: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '10px',
    backgroundColor: '#6750a4',
    color: '#ffffff',
    textDecoration: 'none',
    padding: '14px 24px',
    borderRadius: '100px',
    fontSize: '1rem',
    fontWeight: '500',
    marginBottom: '16px',
    transition: 'background-color 0.3s ease',
  },
};

export default NotFound;
